import React, { Component } from 'react';

export default class ArrowLeft extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M26.021,41.41c-0.678,-1.057 -0.689,-2.455 0.672,-3.885l21.664,-21.664c0.717,-0.682 1.642,-1.045 2.647,-1.021c2.71,0.2 4.391,3.777 2.303,5.971l-19.189,19.189l19.189,19.189c2.393,2.514 -1.272,8.451 -4.95,4.95l-21.664,-21.664c-0.299,-0.315 -0.522,-0.677 -0.672,-1.065Z"/>
              </g>
            </svg>
        )
    }
}
